module.exports = __webpack_public_path__ + "static/media/sfuidisplay-light-webfont.ac78af7b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sfuidisplay-light-webfont.woff
// module id = 262
// module chunks = 0